'use es6';

import { getDndAreaElementForNode, getDndAreaRowElementByIdInTree } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { updateRowElementClasses } from 'layout-dnd-utils/render/renderRows';
import { updateCellElementStyleAttributes } from 'layout-dnd-utils/render/renderColumns';
export const updateStylesOfLayoutTreeNodes = nodesWithChangedStyles => {
  nodesWithChangedStyles.forEach(changed => {
    const {
      currentNode,
      previousNode
    } = changed;
    if (currentNode.isRow()) {
      const rowElement = getDndAreaRowElementByIdInTree(currentNode.getParentName(), currentNode.getName());
      updateRowElementClasses(rowElement, currentNode.getValue().cssClass, previousNode.getValue().cssClass);
    } else {
      const cellElement = getDndAreaElementForNode(currentNode);
      updateCellElementStyleAttributes(cellElement, currentNode.getParams(), previousNode.getParams());
    }
  });
};